import { saveAs } from 'file-saver';

import { fetchApi } from 'shared/functions';
import { downloadBase64File } from './downloadBase64File';
import { downloadServiceWithRetries } from './downloadServiceWithRetries';

type DownloadServiceParams = {
  path: string;
  name: string;
  options?: Record<string, unknown>;
  retries?: number;
  onError: (error: any) => void;
  onDownloadNotReady?: (message: string) => void;
};

export const downloadService = async ({
  path,
  name,
  options,
  retries,
  onError,
  onDownloadNotReady = undefined,
}: DownloadServiceParams): Promise<boolean> => {
  if (retries) {
    try {
      const response = await fetchApi(path, options, [], false, false).then((res) => ({
        status: res.status,
        ...res.json(),
      }));

      if (response.generated || response.ok) {
        downloadBase64File(response.file, name);
      } else if (response.status === 202 && onDownloadNotReady) {
        onDownloadNotReady(response.message || 'Document is being generated');
      } else if (response.status === 404) {
        const retryResponse = await downloadServiceWithRetries(path, retries);
        if (retryResponse.generated) {
          downloadBase64File(response.file, name);
        } else {
          onError(response.message || 'Download failed');
          return false;
        }
      } else {
        onError(response.message || 'Download failed');
        return false;
      }
      return true;
    } catch (e) {
      onError((e as Error).message || 'Download failed');
    }

    return false;
  }

  try {
    const response = await fetchApi(path, options);

    if (!response.ok) {
      onError(response.statusText);
    }

    const blob = await response.blob();
    saveAs(blob, name);
    return true;
  } catch (e) {
    onError(e);
  }

  return false;
};
